import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { ArrowLeft, ArrowRight, Calendar, Clock } from "lucide-react";
import PublicLayout from "../components/PublicLayout";
import SEO from "../components/SEO";
import { apiClient } from "../lib/api";

export default function BlogPostPage() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    apiClient.get(`/blog/${slug}`)
      .then((r) => setPost(r.data))
      .catch(() => setPost(null))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return (
      <PublicLayout>
        <div className="container-tm py-24 text-center text-muted-foreground">Chargement…</div>
      </PublicLayout>
    );
  }
  if (!post) {
    return (
      <PublicLayout>
        <div className="container-tm py-24 text-center">
          <h1 className="h-section">Article introuvable</h1>
          <Link to="/blog" className="text-accent mt-4 inline-block">← Tous les articles</Link>
        </div>
      </PublicLayout>
    );
  }

  return (
    <PublicLayout>
      <SEO title={post.title} description={post.excerpt} image={post.cover} />

      <article className="pt-8 pb-20">
        <div className="container-tm max-w-3xl">
          <Link to="/blog" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-accent" data-testid="back-to-blog">
            <ArrowLeft size={14} /> Tous les articles
          </Link>
          <div className="mt-6 inline-flex items-center gap-2 px-3 py-1.5 bg-accent/10 text-accent rounded-full text-xs font-bold">
            {post.category}
          </div>
          <h1 className="h-display mt-5">{post.title}</h1>
          <p className="mt-5 text-muted-foreground text-lg">{post.excerpt}</p>
          <div className="mt-6 flex flex-wrap items-center gap-4 text-sm text-muted-foreground">
            <span className="flex items-center gap-1.5"><Calendar size={13} /> {new Date(post.published_at).toLocaleDateString("fr-FR", { year: "numeric", month: "long", day: "numeric" })}</span>
            <span className="flex items-center gap-1.5"><Clock size={13} /> {post.read_time} min de lecture</span>
            <span>· {post.author}</span>
          </div>
        </div>

        <div className="container-tm max-w-4xl mt-12">
          <div className="rounded-3xl overflow-hidden aspect-[16/9]">
            <img src={post.cover} alt={post.title} className="w-full h-full object-cover" />
          </div>
        </div>

        <div className="container-tm max-w-3xl mt-12 article-body" data-testid="article-body">
          <ReactMarkdown remarkPlugins={[remarkGfm]} components={{ a: ({ href, children }) => (href?.startsWith("http") ? <a href={href} target="_blank" rel="noopener">{children}</a> : <a href={href}>{children}</a>) }}>{post.content}</ReactMarkdown>
        </div>

        <div className="container-tm max-w-3xl mt-16">
          <div className="rounded-3xl bg-accent/10 border border-accent/30 p-8 md:p-10 text-center">
            <h3 className="h-card">Prêt à passer à l&apos;action ?</h3>
            <p className="mt-3 text-muted-foreground">Lancez la simulation gratuite et obtenez en 90 secondes l&apos;estimation précise de votre bien.</p>
            <Link to="/simulateur" className="btn-accent mt-6" data-testid="article-cta-simulateur">
              Simuler mes revenus <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </article>
    </PublicLayout>
  );
}
